export default {
  countryCode: 'GLOBAL',
  regionLinks: [
    {
      title: 'New Zealand',
      slug: 'https://www.firsttable.co.nz',
    },
    {
      title: 'Australia',
      slug: 'https://www.firsttable.com.au',
    },
    { title: 'Canada', slug: 'https://www.firsttable.ca' },
    { title: 'United Kingdom', slug: 'https://www.firsttable.co.uk' },
    { title: 'Ireland', slug: 'https://www.firsttable.ie' },
    { title: 'Bali', slug: 'https://www.firsttable.co.id' },
  ],
};
